export const COLLECTION_FORM = 'wr-collection-form';
